// extracted by mini-css-extract-plugin
module.exports = {"container":"PasswordSetSuccessfully_container__2kFqs","card":"PasswordSetSuccessfully_card__3XoF5","icon":"PasswordSetSuccessfully_icon__1_YZE"};